<!-- 厂务课级签核:工程分类明细  派单厂务工程师 选择厂商 -->
<ng-container *ngIf="taskAssignEdictStatus; else elseTemplate">
  <app-editable-task 
    [facturerData]="facturerData" 
    [sendOrderData]="sendOrderData"
    [electromechanical]="electromechanical" 
    [civilEngineering]="civilEngineering"
    [projectItemInfo]="projectItemInfo"
    [taskAssignDisabled]="taskAssignDisabled"
    [formid]="formid"
    [vendorTaskAssignEdictStatus]='vendorTaskAssignEdictStatus'
    [engineerTaskAssignEdictStatus]="engineerTaskAssignEdictStatus"
    [vendorInfoData]="vendorInfoData" 
    (submitTaskAssignDataEvent)="submitTaskAssignDataEvent.emit($event)"
  >
  </app-editable-task>
</ng-container>
<ng-template #elseTemplate>
  <app-display-task 
    [formid]="formid" 
    [electromechanical]="electromechanical" 
    [civilEngineering]="civilEngineering"
    [vendorInfoData]="vendorInfoData" 
    [getAssignPhone]="getAssignPhone"
    [appAppointStatus]="appAppointStatus" 
    [appointEditStatus]="appointEditStatus"
  >
  </app-display-task>
</ng-template>
